<template>
  <span
      @click="$emit('click')"
      @keyup.enter="$emit('click')"
      @keyup.space="$emit('click')"
      :class="classes"
      class='frcp-btn'
      :aria-label="text"
      role="button"
      tabindex="0">
    <span class='frcp-btn__text'>
      <slot />
    </span>
    <loading-spinner v-if="isLoading" :diameter="16" />
  </span>
</template>

<script>
  import LoadingSpinner from './loading_spinner.vue'

  export default {
    components: { LoadingSpinner },
    props: {
      type: String,
      text: String,
      isLoading: Boolean,
      isDisabled: Boolean,
    },
    computed: {
      classes() {
        let classList = []
        if (this.isLoading) {
          classList.push('frcp-btn--loading')
        } else if (this.isDisabled) {
          classList.push('frcp-btn--disabled')
        }
        if (this.type == 'secondary') {
          classList.push('frcp-btn--secondary')
        } else {
          classList.push('frcp-btn--primary') // primary by default
        }
        return classList.join(' ')
      },
    },

    emits: ['click'],
  }
</script>
